/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Office/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import City from './City/index'
import Name from './Name/index'
import React from 'react'
import State from './State/index'
import Street from './Street/index'
import Zip from './Zip/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Office({
  children,
  viewPath = "/DesignSystem/DataVaxiomProfessionalView/Content/Details/Office"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Office.Vertical"
  data-view-path={viewPath}
 style={{'--pr-1-Z2hO0oT': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Street
  viewPath={`${viewPath}/Street`}
/>
<City
  viewPath={`${viewPath}/City`}
/>
<State
  viewPath={`${viewPath}/State`}
/>
<Zip
  viewPath={`${viewPath}/Zip`}
/>
</div>
{children}
</React.Fragment>)
}